import React from "react";

const ChatListShimmer = () => {
  return (
    <div className="p-2 pt-4">
      <div className="flex gap-1 justify-between items-center">
        <div className="bg-gray-300 rounded-full w-12 h-12 animate-pulse"></div>
        <div className=" bg-gray-300 my-2 rounded-lg w-10/12 h-16 animate-pulse"></div>
      </div>
      <div className="flex gap-1 justify-between items-center">
        <div className="bg-gray-300 rounded-full w-12 h-12 animate-pulse"></div>
        <div className=" bg-gray-300 my-2 rounded-lg w-10/12 h-16 animate-pulse"></div>
      </div>
      <div className="flex gap-1 justify-between items-center">
        <div className="bg-gray-300 rounded-full w-12 h-12 animate-pulse"></div>
        <div className=" bg-gray-300 my-2 rounded-lg w-10/12 h-16 animate-pulse"></div>
      </div>
      <div className="flex gap-1 justify-between items-center">
        <div className="bg-gray-300 rounded-full w-12 h-12 animate-pulse"></div>
        <div className=" bg-gray-300 my-2 rounded-lg w-10/12 h-16 animate-pulse"></div>
      </div>
    </div>
  );
};

export default ChatListShimmer;
